// extracted by mini-css-extract-plugin
export default {"main":"CountrySelector_main__qQta0"};